<template>
  <div class="container-fluid">
    <!-- Container-fluid starts-->
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <KundeWohnungen />
          </div>         
        </div>
      </div>
    </div>
  </div>
  <!-- Container-fluid Ends-->
</template>

<script>
import KundeWohnungen from "@/widget/kunde/KundeWohnungen.vue";

export default {
  name: "KundeWohnungOverview",
  components: {
    KundeWohnungen,
  },
  async created() {},
  methods: {},
};
</script>
